import Vue from 'vue'
import Router from 'vue-router'
import login from './components/Login'
import ThankYouPage from "@/components/ThankYouPage";
const survey = () => import('./components/Survey');
const startSurvey = () => import('./components/StartSurvey');
const  counterApp = () => import('./components/CounterApp');
const  webLog = () => import('./components/WebLogs');
Vue.use(Router);

export default new Router({
  mode :'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: login
    },
    {
      path:'/StartSurvey',
      name: 'StartSurvey',
      component: startSurvey
    },
    {
      path:"/survey/:id",
      name: 'Survey',
      component: survey,
      props : true
    },
    {
      path:"/counter",
      name: 'CounterApp',
      component: counterApp
    },
    {
      path:"/logs",
      name: 'Logs',
      component: webLog
    },
    {
        path:"/survey-saved",
          name: 'ThankYouPage',
          component: ThankYouPage
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
